export enum FileType {
    Personal = "Personal",
    Company = "Company",
    Sample = "Sample",
}